import { render, staticRenderFns } from "./TextWithColorElementComponent.vue?vue&type=template&id=3514be8a&"
import script from "./TextWithColorElementComponent.vue?vue&type=script&lang=ts&"
export * from "./TextWithColorElementComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3514be8a')) {
      api.createRecord('3514be8a', component.options)
    } else {
      api.reload('3514be8a', component.options)
    }
    module.hot.accept("./TextWithColorElementComponent.vue?vue&type=template&id=3514be8a&", function () {
      api.rerender('3514be8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Table/Elements/TextWithColorElementComponent.vue"
export default component.exports